import { createApi, fetchBaseQuery } from '@reduxjs/toolkit/query/react';
import { config } from '../../config';
import { VersionInfo } from '../types/util/versionInfo';
import { addAuthHeaders } from '../../api';

// Define a service using a base URL and expected endpoints
export const versionApi = createApi({
  reducerPath: 'version',
  baseQuery: fetchBaseQuery({
    baseUrl: config.API_URL,
    prepareHeaders: (h) => addAuthHeaders(config, h), // Adds msal auth headers
  }),
  endpoints: (builder) => ({
    // Example GET request
    getVersion: builder.query<VersionInfo, void>({
      query: () => 'version',
    }),
  }),
});

export default versionApi.reducer;

// Export hooks for usage in functional components, which are
// auto-generated based on the defined endpoints
export const { useGetVersionQuery } = versionApi;
